import React from 'react';
import {Typography} from '@genestack/ui';
import {ContinuantStatRecord} from '../interface';
import {matchString} from './use-filter-stats';
import {HighlightedText} from '../../../../../../components/highlighted-text';

interface Props {
    continuant: ContinuantStatRecord;
    searchValue: string;
}

export function MatchedSynonym(props: Props) {
    const matchedSynonyms = React.useMemo(
        () =>
            props.searchValue
                ? props.continuant.synonyms
                      .filter((synonym) => matchString(synonym, props.searchValue!))
                      .sort((s1, s2) => s1.length - s2.length)
                : [],
        [props.continuant, props.searchValue]
    );

    if (
        !props.searchValue ||
        matchString(props.continuant.label, props.searchValue) ||
        !matchedSynonyms.length
    ) {
        return null;
    }

    return (
        <Typography intent="quiet">
            <HighlightedText text={matchedSynonyms[0]} value={props.searchValue} />
        </Typography>
    );
}
